import { trackEvent } from "@/utils/analytics";

// /lexi-pro sends half its CTA clicks straight to the Stripe Payment Link and
// half to the sign-up form. Recording which path a visitor got lets a later
// Purchase in the same tab say which half it came through.
const STORAGE_KEY = "lexiProVariant";

export const LEXI_PRO_VARIANTS = {
  PAYMENT_LINK: "payment_link",
  SIGNUP_FORM: "signup_form",
};

export const trackLexiProCtaClick = (variant) => {
  try {
    window.sessionStorage?.setItem(STORAGE_KEY, variant);
  } catch {
    // Storage blocked: the click is still tracked, the Purchase just can't say
  }
  return trackEvent("lexi_pro_cta_click", { lexi_pro_variant: variant });
};

export const getLexiProVariant = () => {
  try {
    return window.sessionStorage?.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
};
